import { useContext } from "react";

import { ThemeContext, type ThemeContextValue } from "./ThemeProvider";

export type { ResolvedTheme, ThemeContextValue, ThemeMode } from "./ThemeProvider";

export function useTheme(): ThemeContextValue {
  const value = useContext(ThemeContext);
  if (value === null) {
    throw new Error("useTheme must be used within ThemeProvider");
  }
  return value;
}
